import { styled } from "styled-components";
import { useEffect, useState } from "react";
import Flow from "./Flow";
import { formatTime } from '../../utils/helpers';
import useMessages from '../../utils/useMessages';

const Root = styled.div`
  backdrop-filter: blur(2px);
  bottom: var(--space-6);
  font-family: 'Courier New', Courier, monospace;
  position: absolute;
  right: var(--space-6);
  width: 432px;
  z-index: 1;
`;

const List = styled(Flow)`
  li {
    display: flex;
    gap: var(--space-1);

    &:not(:last-child) {
      border-bottom: var(--border);
      padding-bottom: var(--space-1);
    }
  }

  .type {
    &.error {
      color: red;
    }

    &.success {
      color: green;
    }
  }
`;

function Messages({ store }) {

  const message = useMessages();
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
      setOpen(true);
      // TODO:
      //const timer = setTimeout(() => {
      //  setOpen(false);
      //  console.log('hide');
      //}, 7500);
    //return () => clearTimeout(timer);
  }, [message]);

  return (
    <>
      {isOpen &&
        <Root $isOpen={isOpen}>
          <List as="ul" $space={1}>
            {message.get().map((message,idx) => (
              <li key={idx}>
                <div className={`type ${message.messageType == 'error' ? 'error' : 'success'}`}>[{ formatTime(message.timestamp) }]</div>
                <div>{message.message}</div>
              </li>
            ))}
          </List>
        </Root>
      }
    </>
  )
}

export default Messages;
